<template>
  <el-dialog
    title="新建转账"
    :visible.sync="visible"
    width="520px"
    :destroy-on-close="true"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
      <el-form-item label="转出账号" prop="fromUserType">
        <el-select
          v-model="form.fromUserType"
          placeholder="请选择转出科目"
          style="width: 100%"
          @change="onFromChange"
        >
          <el-option
            v-for="item in fromAccountOptions"
            :key="'from-' + item.userType"
            :label="item.userTypeName"
            :value="item.userType"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="转入账号" prop="toUserType">
        <el-select
          v-model="form.toUserType"
          placeholder="请先选择转出科目"
          style="width: 100%"
          :disabled="!form.fromUserType"
          :loading="toAccountsLoading"
          @change="onToChange"
        >
          <el-option
            v-for="item in toAccountOptions"
            :key="'to-' + item.userType"
            :label="item.userTypeName"
            :value="item.userType"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="币种" prop="coin">
        <el-select
          v-model="form.coin"
          placeholder="请先选择转出/转入科目"
          style="width: 100%"
          :loading="coinsLoading"
          :disabled="!form.fromUserType || !form.toUserType"
        >
          <el-option v-for="c in coinOptions" :key="c" :label="c" :value="c" />
        </el-select>
      </el-form-item>
      <el-form-item label="转账金额" prop="amount">
        <el-input-number
          v-model="form.amount"
          :controls="false"
          :min="0"
          :precision="8"
          style="width: 100%"
          placeholder="请输入金额"
          :disabled="!form.fromUserType || !form.toUserType"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submitting"
        :disabled="!form.fromUserType || !form.toUserType"
        @click="submit"
      >
        确定转账
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '../api';

export default {
  name: 'PublicSubjectTransferCreateDialog',
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      submitting: false,
      coinsLoading: false,
      toAccountsLoading: false,
      fromAccountOptions: [],
      toAccountOptions: [],
      coinOptions: [],
      form: {
        fromUserType: null,
        toUserType: null,
        coin: '',
        amount: undefined,
      },
      rules: {
        fromUserType: [{ required: true, message: '请选择转出账号', trigger: 'change' }],
        toUserType: [{ required: true, message: '请选择转入账号', trigger: 'change' }],
        coin: [{ required: true, message: '请选择币种', trigger: 'change' }],
        amount: [
          { required: true, message: '请输入转账金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value == null || Number(value) <= 0) {
                callback(new Error('金额须大于 0'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.resetForm();
        this.loadFromAccounts();
      }
    },
  },
  methods: {
    resetForm() {
      this.form = { fromUserType: null, toUserType: null, coin: '', amount: undefined };
      this.toAccountOptions = [];
      this.coinOptions = [];
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    handleClose() {
      this.visible = false;
    },
    loadFromAccounts() {
      api.accounts().then((res) => {
        if (res && res.code === 0) {
          this.fromAccountOptions = res.data || [];
        } else {
          this.fromAccountOptions = [];
          this.$message.error((res && res.msg) || '加载科目失败');
        }
      });
    },
    onFromChange() {
      this.form.toUserType = null;
      this.form.coin = '';
      this.coinOptions = [];
      this.toAccountOptions = [];
      if (!this.form.fromUserType) {
        return;
      }
      this.toAccountsLoading = true;
      api
        .allowedTo(this.form.fromUserType)
        .then((res) => {
          if (res && res.code === 0) {
            this.toAccountOptions = res.data || [];
          } else {
            this.toAccountOptions = [];
            this.$message.error((res && res.msg) || '加载转入科目失败');
          }
        })
        .finally(() => {
          this.toAccountsLoading = false;
        });
    },
    onToChange() {
      this.form.coin = '';
      this.loadCoins();
    },
    loadCoins() {
      const { fromUserType, toUserType } = this.form;
      if (!fromUserType || !toUserType) {
        this.coinOptions = [];
        return;
      }
      this.coinsLoading = true;
      api
        .coins({ fromUserType, toUserType })
        .then((res) => {
          if (res && res.code === 0) {
            this.coinOptions = res.data || [];
          } else {
            this.coinOptions = [];
            this.$message.error((res && res.msg) || '加载币种失败');
          }
        })
        .finally(() => {
          this.coinsLoading = false;
        });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        api
          .create({ ...this.form })
          .then((res) => {
            if (res && res.code === 0) {
              this.$message.success('转账成功');
              this.$emit('success');
              this.handleClose();
            } else {
              this.$message.error((res && res.msg) || '转账失败');
            }
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>
